import * as yup from 'yup';

export const schema = yup.object({
  des_unidade: yup.string().trim().min(2).required(),
  des_medida: yup.string().trim().required(),
});
